import { Bot, Building2, ClipboardPlus, FolderKanban, Headset, Images, Settings, Users, Wrench } from 'lucide-react';

import { createLucideSidebarIcon } from './createLucideSidebarIcon';

export const LucideNavIcons = {
  Projects: createLucideSidebarIcon(FolderKanban),
  Customers: createLucideSidebarIcon(Building2),
  Users: createLucideSidebarIcon(Users),
  AiPlayground: createLucideSidebarIcon(Bot),
  Tools: createLucideSidebarIcon(Wrench),
  MediaStudio: createLucideSidebarIcon(Images),
  ProjectRequest: createLucideSidebarIcon(ClipboardPlus),
  Settings: createLucideSidebarIcon(Settings),
  Contact: createLucideSidebarIcon(Headset),
};
